"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludeFieldsByCondition = exports.checkCondition = void 0;
var lodash_1 = __importDefault(require("lodash"));
var auth_1 = require("./auth");
var checkCondition = function (conditions, values, extractor) {
    if (!conditions) {
        return true;
    }
    return Object.keys(conditions).reduce(function (acc, c) {
        var value = extractor ? extractor(c, values) : values[c];
        // AND operator is hardcoded for now
        // Add more operators in the future
        if (acc && lodash_1.default.isArray(value)) {
            return lodash_1.default.includes(value, conditions[c]);
        }
        else if (Object.keys(conditions).length > 1) {
            // A list means "one of", a single value means "equals" - same as
            // the single-key branches below (includes() on a boolean is always false).
            return (acc &&
                (lodash_1.default.isArray(conditions[c])
                    ? lodash_1.default.includes(conditions[c], value)
                    : value === conditions[c]));
        }
        else if (lodash_1.default.isArray(conditions[c])) {
            return lodash_1.default.includes(conditions[c], value);
        }
        else {
            return value === conditions[c];
        }
    }, true);
};
exports.checkCondition = checkCondition;
var checkPropertyStructureCondition = function (conditions, values) {
    if (values.initial_info.structure_type === conditions[0].structure_type) {
        return true;
    }
    return (values.initial_info.structure_type === conditions[1].structure_type &&
        values.initial_info.property_type === conditions[1].property_type);
};
// Certain fields should be visible conditionally based on other field values
var excludeFieldsByCondition = function (rows, values) {
    return rows
        .map(function (row) {
        var r = row.row_descriptor;
        // Entire row can be hidden from config
        if (!exports.checkCondition(row.config.displayCondition, values, valueByFieldName) ||
            (row.config.propertyStructureCondition &&
                !checkPropertyStructureCondition(row.config.propertyStructureCondition, values))) {
            return {};
        }
        // Or individual fields can be hidden separately
        return Object.keys(r).reduce(function (acc, fieldName) {
            var field = r[fieldName];
            var isVisible = false;
            if (!field.displayCondition &&
                !field.favoriteUserDisplayCondition) {
                acc[fieldName] = field;
                return acc;
            }
            if (field.displayCondition) {
                isVisible = exports.checkCondition(field.displayCondition, values, valueByFieldName);
            }
            if (field.favoriteUserDisplayCondition) {
                isVisible = auth_1.getIsFavoriteUser();
            }
            if (isVisible) {
                acc[fieldName] = field;
            }
            return acc;
        }, {});
    })
        .filter(function (r) {
        // Filter out empty rows
        return !lodash_1.default.isEmpty(r);
    });
};
exports.excludeFieldsByCondition = excludeFieldsByCondition;
var valueByFieldName = function (name, values) {
    var sectionNames = Object.keys(values);
    var flattenedFields = sectionNames.reduce(function (acc, n) {
        var _a;
        // Most of the time it's a nested object,
        // but in some cases ('deal' field for instance)
        // we have a value right away
        if (!lodash_1.default.isObject(values[n])) {
            return __assign(__assign({}, acc), (_a = {}, _a[n] = values[n], _a));
        }
        return __assign(__assign({}, acc), values[n]);
    }, {});
    return flattenedFields[name];
};
